// Module
var code = `<div class="investing-change-password-screen {{^(.visible)}}hidden {{/}}">
    <div class="investing-change-password-closeBtn">
        <investingButton investingButtonStyle="close_button" on-btnClick="@this.closeScreenEventClick()" />
    </div>
    <div class="name_change_screen">{{header}}</div>

    <div class="edit_change_section">
        <investingPasswordTextBox passwordHided="{{curPassHided}}" elementStyle="investing_input_container_login" text="{{.curPwd}}" placeholder="{{.curPwdLabel}}" showPasswordPreview="{{.allowPreviewPassword}}"/>
        <investingPasswordTextBox passwordHided="{{newPassHided}}" elementStyle="investing_input_container_login" text="{{.newPwd}}" placeholder="{{.newPwdLabel}}" showPasswordPreview="{{.allowPreviewPassword}}"/>
        <investingPasswordTextBox passwordHided="{{confirmPassHided}}" elementStyle="investing_input_container_login" text="{{.newPwdConfirm}}" placeholder="{{.newPwdConfirmLabel}}" showPasswordPreview="{{.allowPreviewPassword}}"/>
    </div>
    <div class="footer_btns_section">
        <investingButton investingButtonStyle="transparent_button_investing" width="98" height="32" text="{{.cancelText}}" on-btnClick="@this.closeScreenEventClick()" />
        <investingButton investingButtonStyle="blue_button_investing" width="98" height="32" text="{{.okText}}" on-btnClick="ok" />
    </div>
</div>`;
// Exports
export default code;